export default {
	authStatusChange(state, payload) {
		state.isAuth = payload
	},
	authStatusLogout(state, payload) {
		state.isAuth = payload
		state.token = null
	}
}
